var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, Defaults, P, PropertyConverters, Utils, Watch } from '@pacem/pacem-core';
import { PacemContenteditableButtonCommandElement, CONTENTELEMENT_BUTTONCOMMAND_TEMPLATE } from './types';
import { ContenteditableUtils } from './utils';
//namespace Pacem.Components.Scaffolding {
function getAlignIcon(align) {
    return 'format_align_' + align;
}
let PacemContenteditableAlignCommandElement = class PacemContenteditableAlignCommandElement extends PacemContenteditableButtonCommandElement {
    isRelevant(range) {
        const els = ContenteditableUtils.findSurroundingSiblingBlockElements(range);
        if (Utils.isNullOrEmpty(els)) {
            return false;
        }
        const el = els[0], textAlign = getComputedStyle(el).textAlign;
        return textAlign == this.align;
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'align') {
            if (Utils.isNullOrEmpty(this.icon) || this.icon === getAlignIcon(old)) {
                this.icon = getAlignIcon(val);
            }
            if (Utils.isNullOrEmpty(this.altText) || this.altText === old) {
                this.altText = val;
            }
        }
    }
    exec() {
        const elements = ContenteditableUtils.findSurroundingSiblingBlockElements(this.range);
        let targetAlign;
        for (let el of elements) {
            if (ContenteditableUtils.isBlockElement(el) && el instanceof HTMLElement) {
                // normalize alignment: pick one element (the 1st one) to rule them all
                if (Utils.isNull(targetAlign)) {
                    targetAlign = Utils.hasClass(el, 'text-' + this.align) ? '' : this.align;
                }
                el.style.textAlign = '';
                Utils.removeClass(el, 'text-left text-right text-center text-justify');
                if (!Utils.isEmpty(targetAlign)) {
                    Utils.addClass(el, 'text-' + targetAlign);
                }
            }
        }
        return Promise.resolve();
    }
};
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemContenteditableAlignCommandElement.prototype, "align", void 0);
PacemContenteditableAlignCommandElement = __decorate([
    CustomElement({
        tagName: P + '-contenteditable-aligncommand', shadow: Defaults.USE_SHADOW_ROOT,
        template: CONTENTELEMENT_BUTTONCOMMAND_TEMPLATE
    })
], PacemContenteditableAlignCommandElement);
export { PacemContenteditableAlignCommandElement };
